import { z } from 'zod/v4';
import { EEntityType } from './text-relation-type.enums';
import { ETextType } from './text/text.enums';
import {
  INormalText,
  NORMAL_TEXT_SCHEMA,
  NormalTextId,
  TextId,
  TextLanguageValueId,
} from './text/text.interfaces';
import { Brand } from '../branded-types';
import { LanguagePrefix } from './language.interfaces';

export type SalutationId = Brand<string, 'salutationId'>;

export interface ISalutation {
  id?: SalutationId;
  texts: INormalText[];
}

export const SALUTATION_SCHEMA: z.ZodType<ISalutation> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as SalutationId)
    .optional(),
  texts: z.array(NORMAL_TEXT_SCHEMA),
});

export const SALUTATIONS_SCHEMA: z.ZodType<ISalutation[]> =
  z.array(SALUTATION_SCHEMA);

export const DEFAULT_SALUTATIONS: ISalutation[] = [
  {
    id: 'c1b254d6-5ca5-4511-92eb-2f771ed7e68d' as SalutationId,
    texts: [
      {
        id: 'fabf55db-826b-4adc-a798-536bc859c3d5' as NormalTextId,
        textType: ETextType.Web,
        entityType: EEntityType.salutation,
        relationType: '0',
        text: {
          id: 'e3dba64a-ca88-471c-a426-077909c146f9' as TextId,
          values: [
            {
              id: '75a90ffd-3412-4312-ad69-4eaf8dae0095' as TextLanguageValueId,
              languagePrefix: 'DE' as LanguagePrefix,
              value: 'Frau',
            },
          ],
        },
      },
    ],
  },
  {
    id: '7446cb39-3f3a-44dd-a879-400b643335e7' as SalutationId,
    texts: [
      {
        id: '5c643ff8-f36f-4419-9da4-9af5379105cf' as NormalTextId,
        textType: ETextType.Web,
        entityType: EEntityType.salutation,
        relationType: '1',
        text: {
          id: '0cda9d85-c37a-4d38-8fc3-af81cf429327' as TextId,
          values: [
            {
              id: 'eb41f935-b328-4bec-ae41-54425e576920' as TextLanguageValueId,
              languagePrefix: 'DE' as LanguagePrefix,
              value: 'Herr',
            },
          ],
        },
      },
    ],
  },
  {
    id: '94d487ae-5aab-4c3b-9936-1f57ffcb5a9b' as SalutationId,
    texts: [
      {
        id: 'a58f21c9-3409-4ff4-a5e3-b123a1422bab' as NormalTextId,
        textType: ETextType.Web,
        entityType: EEntityType.salutation,
        relationType: '2',
        text: {
          id: '79e6b4fe-4ce5-41d3-8596-50831efce8d0' as TextId,
          values: [
            {
              id: '41fc2e1d-e21e-409e-9626-50dbbbce88b0' as TextLanguageValueId,
              languagePrefix: 'DE' as LanguagePrefix,
              value: 'nicht angegeben',
            },
          ],
        },
      },
    ],
  },
];
